import { Box, Button } from '@factorialco/deprecated-design-system'

import Callout from 'modules/core/components/Callout'
import i18n from 'modules/core/lib/i18n'

const Errored = ({
  error,
  syncing,
  onSync,
}: {
  error: string
  syncing: boolean
  onSync: () => void
}) => {
  return (
    <Box
      background="white"
      paddingX="s24"
      paddingY="s16"
      borderRadius={{
        all: 'abs008',
      }}
      gap="s16"
    >
      <Callout
        type="critical"
        title={i18n.t('payroll_integrations.incidences.a3innuva.errored.title')}
        description={error}
        link={
          <Button onClick={onSync} disabled={syncing}>
            {i18n.t('payroll_integrations.incidences.a3innuva.errored.submit')}
          </Button>
        }
      />
    </Box>
  )
}

export default Errored
